import { BaseType, BaseTypeLiterals } from "../../../domain/base/base-type";

type MFAUiStateLiterals =
  | "INITIAL"
  | MFAUiStateEnableLiterals
  | MFAUiStateDisableLiterals;
type MFAUiStateEnableLiterals = "INPUT_PWD_TO_ENABLE_TOTP" | "INIT_TOTP";
type MFAUiStateDisableLiterals =
  | "INPUT_PWD_TO_DISABLE_TOTP"
  | "CONFIRM_DISABLE_TOTP";
//confirm phase

export type MFAUiStateMatcher<R> = BaseTypeLiterals<MFAUiStateLiterals, R>;

/**
 * 画面の表示状態を表す
 */
export class MFAUiState extends BaseType<MFAUiStateLiterals> {
  static initialize() {
    return new MFAUiState("INITIAL");
  }

  nextMFAUi(isMFAEnabled?: boolean): MFAUiState {
    if (this.equals("INITIAL")) {
      return isMFAEnabled
        ? new MFAUiState("INPUT_PWD_TO_DISABLE_TOTP")
        : new MFAUiState("INPUT_PWD_TO_ENABLE_TOTP");
    }
    if (this.equals("INPUT_PWD_TO_ENABLE_TOTP")) {
      return new MFAUiState("INIT_TOTP");
    }
    if (this.equals("INPUT_PWD_TO_DISABLE_TOTP")) {
      return new MFAUiState("CONFIRM_DISABLE_TOTP");
    }
    return new MFAUiState("INITIAL");
  }
}
